const STATUS_COLORS: Record<string, string> = {
  running: "bg-brand-green/10 text-brand-green",
  active: "bg-brand-green/10 text-brand-green",
  idle: "bg-zinc-700/15 text-text-muted",
  stopped: "bg-zinc-700/15 text-text-muted",
  error: "bg-brand-pink/10 text-brand-pink",
  paused: "bg-amber-500/10 text-amber-400",
  completed: "bg-brand-cyan/10 text-brand-cyan",
  failed: "bg-brand-pink/10 text-brand-pink",
  cancelled: "bg-zinc-700/15 text-text-muted",
  pending: "bg-zinc-700/15 text-text-secondary",
  booting: "bg-amber-500/10 text-amber-400",
  draining: "bg-brand-pink/10 text-brand-pink",
};

export function StatusBadge({ status }: { status: string }) {
  const colors = STATUS_COLORS[status] ?? "bg-zinc-700/15 text-text-muted";
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs ${colors}`}
    >
      {status}
    </span>
  );
}
